import { render, staticRenderFns } from "./AddressConfirmation.vue?vue&type=template&id=7982a548&"
import script from "./AddressConfirmation.vue?vue&type=script&lang=js&"
export * from "./AddressConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports